var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsumptionMonitorBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 19.4 19.4",
    style: {
      enableBackground: "new 0 0 19.4 19.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#004162",
    d: "M18,2.3c-0.3-0.3-0.6-0.4-0.9-0.4H9.7H2.3C1.9,1.9,1.6,2,1.4,2.3C1.1,2.5,1,2.8,1,3.2v11.3 c0,0.3,0.1,0.7,0.4,0.9c0.3,0.3,0.6,0.4,0.9,0.4h4.1v1.7h3.3H13v-1.7h4.1c0.3,0,0.7-0.1,0.9-0.4c0.3-0.3,0.4-0.6,0.4-0.9V3.2 C18.4,2.8,18.3,2.5,18,2.3z M17.1,12.6V14v0.5H9.7H2.3V14v-1.4V3.2h7.4h7.4V12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004162",
    d: "M6.2,5.3H5.7c-0.5,0-1,0.4-1,0.8v5.4c0,0.5,0.4,0.8,1,0.8h0.5c0.5,0,1-0.4,1-0.8V6.1C7.1,5.7,6.7,5.3,6.2,5.3z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004162",
    d: "M8.5,8.6v2.9c0,0.5,0.4,0.8,1,0.8H10c0.5,0,1-0.4,1-0.8V8.6c0-0.2-0.1-0.4-0.2-0.6c-0.2-0.2-0.4-0.3-0.7-0.3 H9.5C9,7.8,8.5,8.2,8.5,8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004162",
    d: "M13.2,12.4h0.5c0.5,0,1-0.4,1-0.8V7.2c0-0.5-0.4-0.8-1-0.8h-0.5c-0.5,0-1,0.4-1,0.8v4.4 C12.3,12,12.7,12.4,13.2,12.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsumptionMonitorBlue);
export default __webpack_public_path__ + "static/media/consumption_monitor_Blue.e25f56436ba494770ecf3e4181df7dca.svg";
export { ForwardRef as ReactComponent };